var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "56px",
    viewBox: "0 0 79 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upper Arm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-12",
    transform: "translate(-49.000000, -94.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,94.92352 C63.295707,104.572488 63.5066142,112.869752 63.6327218,119.815313 C63.6884323,122.883654 65.0852672,126.195976 65.1395407,130.480561 C64.436763,133.970072 63.4216884,140.476552 62.0943169,150 L49.7776975,150 C51.2871884,131.372042 52.4765299,117.596754 53.3457221,108.674136 C53.7210111,104.821639 53.7820193,104.066644 53.8253382,103.945843 L53.8320743,103.93168 C53.8376373,103.923671 53.8431643,103.924397 53.8493309,103.928248 L53.8612675,103.937339 C53.8713159,103.945149 53.8834126,103.952482 53.8994115,103.943941 C53.9497095,103.917088 54.0998443,103.624212 54.3498158,103.06531 C55.3541367,100.483481 56.3639405,98.7147579 57.3792272,97.7591422 C58.3945139,96.8035265 60.2681049,95.8583191 63,94.92352 Z M113.917238,94.92352 C116.649133,95.8583191 118.522724,96.8035265 119.538011,97.7591422 C120.553298,98.7147579 121.563102,100.483481 122.567422,103.06531 C123.13314,103.213427 123.467838,105.083035 123.571516,108.674136 C124.440708,117.596754 125.63005,131.372042 127.139541,150 L127.139541,150 L114.822921,150 C113.49555,140.476552 112.480475,133.970072 111.777697,130.480561 C111.831971,126.195976 113.055142,122.883654 113.110852,119.815313 C113.23696,112.869752 113.505755,104.572488 113.917238,94.92352 Z",
    id: "Upper-Arm"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperArm);
export default __webpack_public_path__ + "static/media/UpperArm.6f30b0718e6e456b505935eb8a340f2a.svg";
export { ForwardRef as ReactComponent };